import { render, staticRenderFns } from "./CompArticleQuote.vue?vue&type=template&id=7ffbcff1&scoped=true"
import script from "./CompArticleQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleQuote.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompArticleQuote.vue?vue&type=style&index=0&id=7ffbcff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbcff1",
  null
  
)

export default component.exports